import { connect } from 'react-redux';
import { cancelRowEditOrder, changeClassesEditOrder, changeEditOrder, changeItemEditOrder, checkedAllItemsEditOrder, searchItemCodeEditOrder } from './../../../../../actions/editOrder';
import RowItemComponent from './../../../components/items/RowItemComponent';
import { onChangeItemName, getListItemName } from './../../../../../actions/getListItemName'
import './RowItem.css';

class RowItem extends RowItemComponent { }

const mapStateToProps = state => {
    return {
        classes: state.editOrder.classes,
        itemOrder: state.editOrder.items,
        order: state.editOrder
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeItem: payload => {
            dispatch(changeItemEditOrder(payload))
        },
        onChange: payload => {
            dispatch(changeEditOrder(payload))
        },
        onChangeClasses: payload => {
            dispatch(changeClassesEditOrder(payload))
        },
        searchItemCode: payload => {
            dispatch(searchItemCodeEditOrder(payload))
        },
        checkedAllItems: payload => {
            dispatch(checkedAllItemsEditOrder(payload))
        },
        cancelRowEditOrder: payload => {
            dispatch(cancelRowEditOrder(payload))
        },
        getListItemName: payload => {
            dispatch(getListItemName(payload))
        },
        onChangeItemName: payload => {
            dispatch(onChangeItemName(payload))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RowItem)



// WEBPACK FOOTER //
// ./src/containers/orders/edit/components/items/RowItem.js